import React from 'react'

import { useOptInPromo } from 'hooks/useOptInPromo'

import classes from './styles.module.scss'

type OptInPromoBannerProps = {
  utmCode: string
  imageUrl: string
  alt?: string
}

export default function OptInPromoBanner(props: OptInPromoBannerProps) {
  const handleOptIn = useOptInPromo()

  const handleClick = () => {
    handleOptIn(props.utmCode)
  }

  return (
    <div
      className={classes.root}
      onClick={handleClick}
      tabIndex={0}
      role='button'
      aria-label={'Promotional banner - Click to opt in'}
      onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleClick()
        }
      }}
    >
      <img
        src={props.imageUrl}
        alt={props.alt || 'Promotional banner'}
        className={classes.bannerImage}
        loading='lazy'
      />
    </div>
  )
}
